import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Loader from 'src/app/components/Loader';
import { shouldRedirect } from 'src/app/redux/actions/isLoggedIn';


class AuthorizationGuardContainer extends React.PureComponent {

  componentDidMount() {
    const { dispatch, logged } = this.props;
    dispatch(shouldRedirect(logged));
  }

  componentDidUpdate() {
    const { dispatch, logged } = this.props;
    dispatch(shouldRedirect(logged));
  }

  render() {
    const { logged, children } = this.props;

    return (
      logged || logged === null ? <Loader /> : children
    );
  }
}

AuthorizationGuardContainer.propTypes = {
  logged: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired
};

AuthorizationGuardContainer.defaultProps = {
  logged: null
};

const mapStateToProps = (state) => ({
    ...state.authorizeReducer
});

export default connect(mapStateToProps)(AuthorizationGuardContainer);
